module.exports = __webpack_public_path__ + "media/images/img_recommend_02-5ec6c7b0d82acf91202d324d974ab413.png";